import { render, staticRenderFns } from "./notification-component.vue?vue&type=template&id=64da55a9&scoped=true&lang=pug"
import script from "./notification-component.js?vue&type=script&lang=js&external"
export * from "./notification-component.js?vue&type=script&lang=js&external"
import style0 from "./notification-component.vue?vue&type=style&index=0&id=64da55a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da55a9",
  null
  
)

export default component.exports